<template>
  <div class="lotto_event_wrap">
    <div class="lotto_num_list">
      <div class="num_ball" v-for="(lotto, idx) in lottoList" :key="idx" :style="`background:${lotto.color}`" @click="selectObj(lotto)">{{ lotto.num }}</div>
    </div>
    <div class="selected_lotto_list">
      <div class="text">
        <span>내번호</span>
        <span>자동</span>
      </div>
      <div class="list_wrap">
        <div class="selected_ball_list">
          <div v-for="(lotto, idx) in 6" :key="idx" :class="selectedList[idx] ? 'num_ball' : 'default'" 
          :style="selectedList[idx]  ? `background:${selectedList[idx].color}` : 'background:#F2F3F6;'"
           @click="selectedList[idx] ? selectObj(selectedList[idx]) : null">
           <template v-if="selectedList[idx]">
             {{ selectedList[idx].num }}
           </template>
          </div>
        </div>
        <img src="images/basic/icon/Group 2 Copy.svg" alt="" @click="randLotto">
      </div>
    </div>
    <div class="apply btn" :class="selectedList.length == 6 ? 'submit' : ''" @click="joinEvent">
      <a href="javascript:void(0)">이벤트 참여하기 -5 FUS</a>
    </div>
    <p>보유 FUS: {{ accountCoin }} FUS</p>
  </div>
</template>

<script>
import { joinEvent } from '@/api/event'
/** created by bhs 2022-02-03
   * vue 는 data 와 ui 가 강력하게 binding 되어있습니다.
   * 상기 template 태그속 'v-' 로 선언된 곳들을 확인해 보시면 
   * binding 된 data 의 변경에따라 자동으로 ui 를 refresh 하게됩니다.
   * 
   * 자주 쓰이는 구문들 정리해드립니다.
   * 1). {{ some_vlaue }}
   * @link = https://kr.vuejs.org/v2/guide/syntax.html
   *  - tag 안에 {{ some_vlaue }} 를 선언해주면 some_value의 변화에따라 보여줄 value 가 자동으로 변화합니다.
   * 
   * 2). v-if 및 v-show
   * @link = https://kr.vuejs.org/v2/guide/conditional.html
   *  - tag 속성에 [v-if="some_value = true"] 삽입하여 some_value의 변화에따라 ui를 변경할 수 있습니다.
   *  - 일반 if ,else if, else 처럼 사용도 가능합니다.
   *    ex). <div v-if="some_value = true">
   *            true 일때
   *          </div>
   *          <div v-else>
   *            그외
   *          </div>
   *  - v-show는 v-if와 비슷하게 사용이 가능하나 if의 경우 조건이 충족되지 않았을 시에 element 가 추가되지 않는반면
   *    v-show는 element 는 항상 존재하되 css속성인 display가 none 및 visible로 바뀌게 됩니다.
   * 
   * 3). v-for
   * @link = https://kr.vuejs.org/v2/guide/list.html
   *  - v-for은 list 데이터에 대해 child들을 반복적으로 제어할때 사용되어집니다.
   *    forin 구문에 선언된 bind 시킨 array 에 대해서 동작함으로 
   *    bind 시킨 array만 변경되어도 자동으로 갯수 변경 및 각 child의 value 에 대한 ui도 자동으로 변경됩니다.
   *    ex). <ul id="container">
   *           <li v-for="child in array">
   *             - 1)의 경우 
   *                {{ child.message }}
   *             - 2)의 경우
   *              <div v-if="child.message != undefined"> {{ child.message }} </div>
   *           </li>
   *         </ul>
   * 
   * 4). @click
   * @link = https://kr.vuejs.org/v2/guide/events.html
   *  - 이 파일의 line 4번 참조 @click="selectObj(lotto)"
   *  - 기존 tag의 onclikc="method()" 를 이용하듯이 module 에 선언된 methods의 function 들을 call 할 수 있습니다.
   * 
   * 5). override funcitons
   *   - 많이 쓰이는 functions [ data(), created(), mounted(), computed:, methods:]
   *   a. data()
   *    i. data() 는 해당파일안에서 전역으로 접근할 수 있는 data 를 만든후 return 시켜줍니다.
   *   b. created()
   *    i. element들이 dom 에 mount 되기전에 불립니다.
   *    ii. 즉 template 태그가 render되기 전에 불립니다.
   *   c. mounted()
   *    i. template 태그가 rendering 된 이후에 불립니다.
   *    ii. 만약 jquery function들을 선언해야 한다면 mounted 안에 선언하시면 됩니다.
   *   d. computed:
   *    i. 선언된 변수는 data와 달리 정제할 수 있습니다.(function 을 가집니다.)
   *    ii. computed는 변경을 옵저빙 하고 있기때문에 함수속 데이터가 변경된다면 자동으로 변경됩니다.
   *   e. methods:
   *    i. 사용하실 function 들을 선언하는 곳입니다.
   *       ex). someFunction(arg) {
   *              //some do
   *              console.log(arg);
   *            }
   *   - life cycle 참조 @link = https://kr.vuejs.org/v2/guide/instance.html#%EC%9D%B8%EC%8A%A4%ED%84%B4%EC%8A%A4-%EB%9D%BC%EC%9D%B4%ED%94%84%EC%82%AC%EC%9D%B4%ED%81%B4-%ED%9B%85
   * 
   * 6). vuex store (like session)
   *  - 현재 session과 엮어 login시 해당 client 의 vuex 의 store 에 userInfo (by userKey) 를 저장하게되어있습니다.
   *    지금은 dev 단계이기 때문에 compile 혹 log 시에 콘솔에서 확인가능하나 release 단계에서는 이를 제한 할 것입니다.
   *  - store 에서 데이터 가져오기
   *    a. mounted가 된이후 store는 lifecycle 의 별도의 부분에 존재하기때문에
   *       사용하실 store의 변수는 [5)의 d ] computed 에 선언하여 사용하여야 합니다.
   *       ex). accountCoin(){
   *              return this.$store.state.userInfo.accountCoin;
   *           }
   *       상기와 같이 사용하시면 userInfo의 accountCoin 이 변경된때만다 accountCoin이 달라지게 됩니다.
   * 
   * 7). 마치며
   *   - vue 의 경우 각 componant 들을 퍄편화 하는되 특화되어 있으며
   *     ui를 data 와 강력하게 binding 시킴으로써 data의 변경만으로 ui에 변화를 줄수있습니다.
   *    
   */
export default {
  data() {
    return {
      randColorList: ['#FBC400', '#6AC7F1', '#FF7170', '#A7A2E0', '#6DCE9D'],
      lottoList: [],
      lottoRequest: false,
    }
  },
  props: {
    accountCoin: {
      type: String
    }
  },
  computed: {
    selectedList() {
      return this.lottoList.filter(lotto => lotto.selected);
    }
  },
  mounted() {
    var lotto_cnt = 45; // 생성할 로또 갯수
    for(var i=0 ; i<lotto_cnt ; i++){
      var lotto = new Object();
      lotto.num = i+1;
      lotto.color = '#e6e9ec'
      lotto.selected = false;
      this.lottoList.push(lotto);
    }
  },
  methods: {
    selectObj(target) {
      var color = '#e6e9ec' // default gray(un selected)
      if(!target.selected){
        color = this.randColorList[parseInt((target.num-1)/10)]
      }
      target.selected = !target.selected;
      target.color = color;
      var selected_array = this.selectedList;
      if(selected_array.length > 6){
        target.selected = !target.selected;
        target.color = '#e6e9ec';
      }
    },
    selectNum(idx, num) {
      if(this.selectedList.some((item) => item.num == num)) {
           this.selectedList.forEach((el, i) => {
           if(el.num == num) {
             this.selectedList.splice(i, 1);
             this.lottoList[idx].color = '#e6e9ec'
           }
         })
      } else if(this.selectedList.length < 6) {
         const randNum = Math.floor(Math.random() * (this.randColorList.length));
         const color = this.randColorList[randNum];
         this.lottoList[idx].color = color
         this.selectedList.push({ color, num })
      }
    },
    randLotto() {
      this.refreshLottoList();
      while( this.selectedList.length < 6){
        const randNum = Math.floor(Math.random() * (this.lottoList.length));
        const color = this.randColorList[parseInt((randNum)/10)]
        var r_lotto = this.lottoList[randNum];
        r_lotto.selected = true
        r_lotto.color = color
      }
    },
    refreshLottoList() {
      this.lottoList.forEach(lotto =>{
        lotto.color = '#e6e9ec';
        lotto.selected = false;
      })
    },
    joinEvent() {
      if(this.selectedList.length != 6){
        alert('번호선택 후 참여가능합니다.')
        return;
      }
      var str = '';
      this.selectedList.forEach(el => {
        str += el.num + ','
      })
      var selectNumberList = str.slice(0, -1)

      if(this.lottoRequest) return;
      this.lottoRequest = true;

      joinEvent({
        nttId: this.$route.query.nttId,
        selectNumberList 
      })
      .then(({ data }) => {
        console.log(data)
        this.lottoRequest = false;
        if(data.resultCode == 1000) {
          alert('참여되었습니다.')
          this.refreshLottoList();
          this.$parent.fetchData();
        }else if(data.resultCode == 5100){
          alert('이벤트 참여 FUS가 부족합니다.');
          this.$parent.fetchData();
        }else if(data.resultCode == 2100){
          alert('이벤트 참여에 실패했습니다.\n잠시후 다시 시도해주세요.');
          this.$parent.fetchData();
        }
      })
    }
  },
}
</script>

<style scoped>
.lotto_event_wrap {
  padding: 30px 20px;
}

.selected_ball_list{
  width: 335px;
  margin: auto;
}
.lotto_num_list{
  width: 100%;
  padding: 0 11px 0 20px;
  margin: 20px auto !important;
}

.selected_ball_list {
  display: flex;
}

.lotto_num_list .num_ball {
  border-radius: 50%;
  width: 34px;
  background: #CDD2DA;
  display: inline-block;
  height: 34px;
  text-align: center;
  color: white;
  font-weight: bold;
  line-height: 34px;
  font-size: 12px;
  margin-right: 9px;
  margin-bottom: 9px;
}

.selected_ball_list .num_ball {
  border-radius: 34px;
  width: 34px;
  background: #CDD2DA;
  display: inline-block;
  height: 34px;
  text-align: center;
  color: white;
  font-weight: bold;
  line-height: 34px;
  font-size: 12px;
  margin-right: 5px;
  margin-bottom: 9px;
}

.selected_ball_list .default {
  border-radius: 33px;
  width: 32px;
  border: 1px dashed #C5C8CF;
  display: inline-block;
  height: 33px;
  text-align: center;
  color: white;
  font-weight: bold;
  line-height: 34px;
  font-size: 12px;
  margin-right: 5px;
  margin-bottom: 9px;
}

.lotto_num_list .num_ball:nth-child(8n) {
  margin-right: 0;
}

.selected_lotto_list {
  background-color: #F2F3F6;
  width: 335px;
  height: 100px;
  margin: auto;
  border-radius: 8px;
  margin-top: 30px;
}

.lotto_event_wrap .apply.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 3px solid var(--Gray-Border);
  height: 56px;
  margin: 30px 0 10px 0;
  transition: 0.4s;
  overflow: hidden;
}
.lotto_event_wrap .apply.btn.submit {
  border: 3px solid transparent;
  background-image: linear-gradient(#fff, #fff), var(--Gradient);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.lotto_event_wrap .apply.btn a {
  font-weight: bold;
  letter-spacing: -1px;
  color: var(--Gray-Lighter);
  transition: 0.4s;
}
.lotto_event_wrap .apply.btn.submit a {
  background: var(--Gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lotto_event_wrap p {
  text-align: center;
  font-size: 14px;
}

.selected_lotto_list .list_wrap {
  display: flex;
  margin-left: 20px;
  vertical-align: middle;
}

.list_wrap img {
  margin-right: 20px;
  margin-bottom: 9px;
}

.selected_lotto_list .text {
  padding: 20px 20px 12px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #9EA3AB;
}
</style>